import React from 'react';
import { ButtonProps, styled } from '@mui/material';
import Button from '@mui/material/Button';

export const Tag = styled(({ children, ...props }: ButtonProps) => (
  <Button {...props} disableRipple>
    {children}
  </Button>
))(() => ({
  padding: '2px 4px',
  margin: 0,
  borderRadius: '4px',
  border: 'none',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  verticalAlign: 'middle',

  backgroundColor: 'var(--dk-bg-muted, #F3F5F6)',
  color: 'var(--dk-accent, #06C)',

  '&.isAuthor': {
    backgroundColor: '#06C',
    color: '#fff',
  },

  '&.Mui-disabled': {
    background: 'var(--dk-bg-subtle, #F9FAFB)',
    color: 'var(--dk-text-disabled, #D1D8E2)',
  },
}));
